/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";

import SidebarCard from "components/sidebar/components/SidebarCard";
import {
  renderThumb,
  renderTrack,
  renderView,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import routes from "routes.js";
import Card from "components/card";
import logo from "assets/img/bewiseapp/logo.png";

const SidebarHorizon = ({ open, onClose, variant }) => {
  return (
    <div
      className={`no-print sm:none duration-175 linear fixed !z-50 min-h-full transition-all md:!z-50 lg:!z-50 xl:!z-0 ${variant === "auth" ? "xl:hidden" : "xl:block"
        } ${open ? "" : "-translate-x-full"}`}
    >
      <Card
        extra={`w-[285px] ml-3 sm:mr-4 sm:my-4 h-[96.5vh] m-7 !rounded-[20px]`}
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
        >
          <div className="flex h-full flex-col justify-between">
            <div>
              <span
                className="absolute top-4 right-4 block cursor-pointer xl:hidden"
                onClick={onClose}
              >
                <HiX />
              </span>
              <div className={`mx-8 my-8 flex items-center `}>
                <img src={logo} />
              </div>
              <div className="mt-[58px] mb-7 h-px bg-gray-200 dark:bg-white/10" />
              {/* Nav item */}
              <ul className="ml-[10px] pt-1">
                <Links routes={routes} />
              </ul>
            </div>
            {/* Free Horizon Card    */}
            {/* <div className="mt-[28px] mb-[150px] flex justify-center">
              <SidebarCard />
            </div> */}
          </div>
        </Scrollbars>
      </Card>
    </div>
  );
};

export default SidebarHorizon;
